import { BaseConfig } from '../ServiceConfig';

export interface ColorConfig {
  primaryColor: OffsetColor;
  errorColor: OffsetColor;
  pendingColor: OffsetColor;
  linkColor: OffsetColor;
  successColor: OffsetColor;
  neutralColor: NeutralColor;
}

export interface OffsetColor {
  color900: string;
  color800: string;
  color700: string;
  color600: string;
  color500: string;
  color400: string;
  color300: string;
  color200: string;
  color100: string;
  color50: string;
}

export interface NeutralColor {
  whiteColor: string;
  tableHeaderColor: string;
  backgroundColor: string;
  dividerColor: string;
  disableColor: string;
  borderColor: string;
  placeholderColor: string;
  secondaryTextColor: string;
  primaryTextColor: string;
  titleTextColor: string;
}

export interface ApolloConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.ApolloServiceConfigData';
  colorConfig: ColorConfig;
}

export const ApolloConfigurationFields: (keyof ApolloConfiguration)[] = [
  'colorConfig',
];

export const BlankApolloConfiguration: ApolloConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.ApolloServiceConfigData',
  colorConfig: {
    primaryColor: {
      color900: '',
      color800: '',
      color700: '',
      color600: '',
      color500: '',
      color400: '',
      color300: '',
      color200: '',
      color100: '',
      color50: '',
    },
    errorColor: {
      color900: '',
      color800: '',
      color700: '',
      color600: '',
      color500: '',
      color400: '',
      color300: '',
      color200: '',
      color100: '',
      color50: '',
    },
    pendingColor: {
      color900: '',
      color800: '',
      color700: '',
      color600: '',
      color500: '',
      color400: '',
      color300: '',
      color200: '',
      color100: '',
      color50: '',
    },
    linkColor: {
      color900: '',
      color800: '',
      color700: '',
      color600: '',
      color500: '',
      color400: '',
      color300: '',
      color200: '',
      color100: '',
      color50: '',
    },
    successColor: {
      color900: '',
      color800: '',
      color700: '',
      color600: '',
      color500: '',
      color400: '',
      color300: '',
      color200: '',
      color100: '',
      color50: '',
    },
    neutralColor: {
      whiteColor: '',
      tableHeaderColor: '',
      backgroundColor: '',
      dividerColor: '',
      disableColor: '',
      borderColor: '',
      placeholderColor: '',
      secondaryTextColor: '',
      primaryTextColor: '',
      titleTextColor: '',
    },
  },
} as ApolloConfiguration;
